// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3NYVZ","question":"styles_question__chbb2","inputVisibleButton":"styles_inputVisibleButton__2iR0s","note":"styles_note__2Ut5n"};